import { jsx as _jsx } from "preact/jsx-runtime";
import IconArrowTiny from '@fandom-frontend/react-common/dist/icons/IconArrowTiny';
import styles from '../styles/ArrowButton.module.scss';
export default function ArrowButton({ position, isActive, onClick, name, ariaLabel }) {
    const arrowCircleClassNames = [
        styles.arrowCircle,
        position === 'left' ? styles.arrowCircleLeft : styles.arrowCircleRight,
        isActive ? styles.arrowCircleIsActive : styles.arrowCircleIsInactive,
    ].join(' ');
    const arrowClassNames = [
        styles.arrow,
        position === 'right' && styles.arrowPositionRight,
        isActive ? styles.arrowIsActive : styles.arrowIsInactive,
    ].join(' ');
    return (_jsx("button", Object.assign({ className: arrowCircleClassNames, onClick: onClick, name: name, "aria-label": ariaLabel }, { children: _jsx(IconArrowTiny, { className: arrowClassNames }, void 0) }), void 0));
}
